<template>
  <hit-panel :resizable="false" panel-id="blacklist-companies">
    <template #body>
      <hit-container
        route="company"
        :attributes="attributes"
        multiple
        :custom-filters="{blocked: 'is.true'}"
        :default-sort="{property: 'designation_legal', order: 'asc'}"
      >
        <template #default="container">
          <hit-container-table
            ref="table"
            :container="container"
            :items-selectable="true"
            :inline-edition-allowed="false"
            :auto-save="false"
            :addable="false"
            :search-field="false"
            :data-list-config="dataListConfig"
          />
        </template>
      </hit-container>
    </template>
  </hit-panel>
</template>

<script>
import {defineComponent} from 'vue';
import {HitContainer, HitContainerTable} from '@hit/base/src/components';
import * as AT from '@hit/base/src/components/container/attributes';
import {useI18n} from 'vue-i18n';

export default defineComponent({
  name: 'BlacklistCompanies',
  components: {
    HitContainer,
    HitContainerTable,
  },
  setup() {
    const {t} = useI18n();
    return {t};
  },
  data() {
    return {
      route: 'company',
      attributes: [
        new AT.StringAttribute({
          name: 'designation',
          column: 'designation_legal',
          tableProperties: {
            header: 'hit-base.common.designation',
            maxWidth: '1.6fr',
          },
        }),
        new AT.StringAttribute({
          name: 'vatNo',
          column: 'vat_no',
          tableProperties: {
            header: 'hit-base.common.vat-no',
          },
        }),
        new AT.StringAttribute({
          name: 'email',
          column: 'email_general',
          tableProperties: {
            header: 'hit-base.common.email-general',
          },
        }),
        new AT.BooleanAttribute({
          name: 'blocked',
          column: 'blocked',
          tableProperties: {
            header: 'hit-base.common.blocked',
          },
        }),
      ],
      dataListConfig: {
        zone1CustomFunction: (item) => {
          return item.blocked
            ? this.t('hit-base.common.blocked')
            : this.t('hit-base.common.unblocked');
        },
        zone2CustomFunction: (item) => {
          return `${item.designation} (${item.vatNo})`;
        },
        zone3CustomFunction: (item) => {
          return `${item.email}`;
        },
      },
    };
  },
});
</script>

<style scoped>
.blacklist-companies {
  padding: 1rem;
  background-color: #f0f0f0;
}
</style>
